import React from "react";

export function useSelection<T>() {
    const [selected, setSelected] = React.useState<T>(null);

    const isSelected = Boolean(selected);
    const clear = () => setSelected(null);

    return  {selected, setSelected, isSelected, clear}
}